<template>
    <div>
        <el-row style="margin-top: 2vh; padding: 20px;">
            <!-- 搜索表单区域 -->
            <el-col :span="24">
                <el-form :inline="true" :model="searchForm" class="demo-form-inline">
                    <el-form-item label="模版名称">
                        <el-input v-model="searchForm.pName" placeholder="请输入模版名称"></el-input>
                    </el-form-item>
                    <el-form-item label="模版类别">
                        <el-select v-model="searchForm.pType" placeholder="请选择模版类别" clearable>
                            <el-option label="海鲜类" value="海鲜类"></el-option>
                            <el-option label="水产类" value="水产类"></el-option>
                            <el-option label="半成品食物类" value="半成品食物类"></el-option>
                            <el-option label="蛋类" value="蛋类"></el-option>
                            <el-option label="鸡肉类" value="鸡肉类"></el-option>
                            <el-option label="猪肉类" value="猪肉类"></el-option>
                            <el-option label="牛肉类" value="牛肉类"></el-option>
                            <el-option label="羊肉类" value="羊肉类"></el-option>
                            <el-option label="农副产品" value="农副产品"></el-option>
                            <el-option label="蔬菜类" value="蔬菜类"></el-option>
                            <el-option label="菌类" value="菌类"></el-option>
                            <el-option label="粮油米面类" value="粮油米面类"></el-option>
                            <el-option label="调味品" value="调味品"></el-option>
                            <el-option label="其他类" value="其他类"></el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item>
                        <el-button type="primary" icon="el-icon-search" @click="getTemplateList()">查询</el-button>
                        <el-button @click="resetSearch()" icon="el-icon-refresh">重置</el-button>
                        <el-button type="primary" icon="el-icon-plus" @click="showAddTemplateDialog()">新增</el-button>
                    </el-form-item>
                </el-form>
            </el-col>

            <!-- 表格区域 -->
            <el-col :span="24" style="margin-top: 20px;">
                <el-table ref="tableRef"
                    :data="templateList.slice((currentPage - 1) * pageSize, currentPage * pageSize)" height="65vh"
                    style="width: 100%;" border :header-cell-class-name="'table-header'" @row-click="handleRowClick">
                    <el-table-column type="selection" width="55" align="center" />
                    <el-table-column label="序号" type="index" width="70" align="center" />
                    <el-table-column prop="pid" label="模版ID" align="center" />
                    <el-table-column prop="pname" label="模版名称" align="center" />
                    <el-table-column prop="ptype" label="模版类别" align="center" />
                    <el-table-column label="模版图片" align="center" width="120">
                        <template #default="scope">
                            <el-image v-if="scope.row.proImgPath" :src="scope.row.proImgPath"
                                style="width: 80px; height: 50px; object-fit: cover; border-radius: 4px; cursor: pointer;"
                                :preview-src-list="[scope.row.proImgPath]" :error="errorImage" fit="cover"></el-image>
                            <span v-else class="text-gray-400">无图片</span>
                        </template>
                    </el-table-column>
                    <el-table-column prop="alDay" label="预警天数" align="center" />
                    <el-table-column prop="alNum" label="预警数量" align="center" />
                    <el-table-column prop="punit" label="单位" align="center" />
                    <el-table-column prop="yieldRate" label="成品率" align="center">
                        <template #default="scope">
                            {{ Number(scope.row.yieldRate).toFixed(2) * 100 }}% <!-- 优化显示，保留两位小数 -->
                        </template>
                    </el-table-column>
                    <el-table-column label="操作" align="center" width="240">
                        <template #default="scope">
                            <el-button type="primary" icon="el-icon-edit" @click="showEditDialog(scope.row)"
                                size="small">修改</el-button>
                            <el-button type="danger" icon="el-icon-delete" @click="handleDeleteTemplate(scope.row.pid)"
                                size="small">删除</el-button>
                        </template>
                    </el-table-column>
                </el-table>

                <!-- 分页区域 -->
                <div style="margin-top: 20px; text-align: center;">
                    <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange"
                        :current-page="currentPage" :page-sizes="[10, 20, 50, 100]" :page-size="pageSize"
                        layout="total, sizes, prev, pager, next, jumper" :total="totalCount"></el-pagination>
                </div>
            </el-col>
        </el-row>

        <!-- 新增/编辑模版弹窗 -->
        <el-dialog :title="dialogTitle" :visible.sync="formDialogVisible" width="700px" :z-index="2000" append-to-body
            modal-append-to-body>
            <el-form :model="templateForm" :rules="templateRules" ref="templateFormRef" label-width="120px"
                class="mt-4">
                <el-form-item label="模版名称" prop="pname">
                    <el-input v-model="templateForm.pname" placeholder="请输入模版名称" />
                </el-form-item>
                <el-form-item label="模版类别" prop="ptype">
                    <el-select v-model="templateForm.ptype" placeholder="请选择模版类别">
                        <el-option label="海鲜类" value="海鲜类"></el-option>
                        <el-option label="水产类" value="水产类"></el-option>
                        <el-option label="半成品食物类" value="半成品食物类"></el-option>
                        <el-option label="蛋类" value="蛋类"></el-option>
                        <el-option label="鸡肉类" value="鸡肉类"></el-option>
                        <el-option label="猪肉类" value="猪肉类"></el-option>
                        <el-option label="牛肉类" value="牛肉类"></el-option>
                        <el-option label="羊肉类" value="羊肉类"></el-option>
                        <el-option label="农副产品" value="农副产品"></el-option>
                        <el-option label="蔬菜类" value="蔬菜类"></el-option>
                        <el-option label="菌类" value="菌类"></el-option>
                        <el-option label="粮油米面类" value="粮油米面类"></el-option>
                        <el-option label="调味品" value="调味品"></el-option>
                        <el-option label="其他类" value="其他类"></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="模版图片" prop="proImgPath">
                    <el-upload class="upload-demo" action="#" :before-upload="beforeImageUpload"
                        :on-change="handleImageChange" :on-remove="handleImageRemove" :headers="uploadHeaders"
                        :show-file-list="false">
                        <el-button size="small" type="primary">点击上传</el-button>
                        <div slot="tip" class="el-upload__tip">只能上传jpg/png文件，且不超过200KB</div>
                    </el-upload>
                    <el-image v-if="templateForm.proImgPath" :src="templateForm.proImgPath"
                        style="width: 120px; height: 80px; object-fit: cover; border-radius: 4px; margin-top: 10px; cursor: pointer;"
                        :preview-src-list="[templateForm.proImgPath]" :error="errorImage" fit="cover"></el-image>
                </el-form-item>
                <el-form-item label="预警天数" prop="alDay">
                    <el-input v-model.number="templateForm.alDay" placeholder="请输入预警天数" />
                </el-form-item>
                <el-form-item label="预警数量" prop="alNum">
                    <el-input v-model.number="templateForm.alNum" placeholder="请输入预警数量" />
                </el-form-item>
                <el-form-item label="成品率" prop="yieldRate">
                    <!-- 核心修改：移除.number修饰符，改为失焦校验 + 输入格式过滤 -->
                    <el-input v-model="templateForm.yieldRate" placeholder="请输入成品率如0.8" @blur="handleYieldRateBlur"
                        @input="handleYieldRateInputFormat" />
                    <div slot="append" style="font-size: 12px; color: #999;">范围：0~1（如0.8表示80%）</div>
                </el-form-item>
                <el-form-item label="单位" prop="punit">
                    <el-select v-model="templateForm.punit" placeholder="请选择单位">
                        <el-option label="g" value="g"></el-option>
                        <el-option label="kg" value="kg"></el-option>
                        <el-option label="罐" value="罐"></el-option>
                        <el-option label="袋" value="袋"></el-option>
                        <el-option label="瓶" value="瓶"></el-option>
                        <el-option label="个" value="个"></el-option>
                    </el-select>
                </el-form-item>
            </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button @click="formDialogVisible = false">取消</el-button>
                <el-button type="primary" @click="submitTemplateForm()">确认</el-button>
            </div>
        </el-dialog>

        <!-- 营养分析弹窗 -->
        <el-dialog title="营养分析" :visible.sync="nutritionDialogVisible" width="900px" :z-index="2000" append-to-body
            modal-append-to-body>
            <div class="nutrition-analysis">
                <el-tabs v-model="activeTab">
                    <el-tab-pane label="营养成分分析" name="nutritionComponent">
                        <div class="nutrition-summary">
                            <div class="nutrition-card">
                                <h3>总热量</h3>
                                <p class="value">{{ nutritionData.totalCalorie || '0' }} kcal</p>
                                <p class="reference">每日参考值约2000kcal</p>
                            </div>
                            <div class="nutrition-card">
                                <h3>蛋白质</h3>
                                <p class="value">{{ nutritionData.protein || '0' }} g</p>
                                <p class="reference">每日参考值约60g</p>
                            </div>
                            <div class="nutrition-card">
                                <h3>脂肪</h3>
                                <p class="value">{{ nutritionData.fat || '0' }} g</p>
                                <p class="reference">每日参考值约65g</p>
                            </div>
                            <div class="nutrition-card">
                                <h3>碳水化合物</h3>
                                <p class="value">{{ nutritionData.carbohydrate || '0' }} g</p>
                                <p class="reference">每日参考值约300g</p>
                            </div>
                        </div>
                        <el-table :data="nutritionData.details" border style="width: 100%; margin-top: 20px;">
                            <el-table-column prop="nutrient" label="营养素" />
                            <el-table-column prop="content" label="含量" />
                            <el-table-column prop="dailyPercentage" label="每日参考值%" />
                            <el-table-column label="操作">
                                <template #default="scope">
                                    <el-button type="text" size="small" @click="editNutrient(scope.row)">编辑</el-button>
                                    <el-button type="text" size="small" class="text-red-500"
                                        @click="deleteNutrient(scope.$index)">删除</el-button>
                                </template>
                            </el-table-column>
                        </el-table>
                        <el-button type="primary" size="small" style="margin-top: 15px;"
                            @click="addNutrient()">添加营养素</el-button>
                    </el-tab-pane>
                    <el-tab-pane label="营养成分占比" name="nutritionChart">
                        <div class="chart-container">
                            <div id="nutritionPieChart" style="width: 100%; height: 400px;"></div>
                        </div>
                    </el-tab-pane>
                </el-tabs>
            </div>
            <div slot="footer" class="dialog-footer">
                <el-button @click="nutritionDialogVisible = false">关闭</el-button>
            </div>
        </el-dialog>

        <!-- 营养素编辑弹窗 -->
        <el-dialog title="编辑营养素" :visible.sync="nutrientDialogVisible" width="500px" :z-index="2100" append-to-body>
            <el-form :model="nutrientForm" :rules="nutrientRules" ref="nutrientFormRef" label-width="120px">
                <el-form-item label="营养素名称" prop="nutrient">
                    <el-input v-model="nutrientForm.nutrient" placeholder="请输入营养素名称"></el-input>
                </el-form-item>
                <el-form-item label="含量" prop="content">
                    <el-input v-model="nutrientForm.content" placeholder="请输入含量（如：15.0 g）"></el-input>
                </el-form-item>
                <el-form-item label="每日参考值%" prop="dailyPercentage">
                    <el-input v-model="nutrientForm.dailyPercentage" placeholder="请输入百分比（如：25%）"></el-input>
                </el-form-item>
            </el-form>
            <div slot="footer">
                <el-button @click="nutrientDialogVisible = false">取消</el-button>
                <el-button type="primary" @click="saveNutrient()">保存</el-button>
            </div>
        </el-dialog>
    </div>
</template>

<script>
import * as echarts from 'echarts'
import { addProducts, editProducts, delProducts, getAllProducts } from "@/api/ingredients";

export default {
    data() {
        return {
            // 搜索表单
            searchForm: {
                pName: '',
                pType: ''
            },
            // 模版列表
            templateList: [],
            // 分页参数
            currentPage: 1,
            pageSize: 10,
            totalCount: 0,
            // 弹窗状态
            formDialogVisible: false,
            dialogTitle: '新增模版',
            nutritionDialogVisible: false,
            nutrientDialogVisible: false,
            // 当前操作类型（add/edit）
            currentOperation: 'add',
            // 标签页激活状态
            activeTab: 'nutritionComponent',

            // 上传配置
            uploadHeaders: {
                Authorization: 'Bearer ' + localStorage.getItem('token')
            },
            errorImage: 'https://via.placeholder.com/150x100?text=无图片',

            // 模版表单数据（核心修改：成品率改为字符串类型）
            templateForm: {
                pid: '',          // 模版ID
                pname: '',        // 模版名称
                ptype: '',        // 模版类别
                proImgPath: '',   // 图片URL（用于预览）
                file: null,       // 图片文件对象（用于上传）
                alDay: '',        // 预警天数
                alNum: '',        // 预警数量
                punit: '',        // 单位
                yieldRate: '1'    // 成品率改为字符串，方便输入小数点
            },

            // 营养分析数据
            nutritionData: {
                totalCalorie: 220.0,
                protein: 15.0,
                fat: 14.0,
                carbohydrate: 10.0,
                details: [
                    { nutrient: '热量', content: '220.0 kcal', dailyPercentage: '11%' },
                    { nutrient: '蛋白质', content: '15.0 g', dailyPercentage: '25%' },
                    { nutrient: '脂肪', content: '14.0 g', dailyPercentage: '22%' },
                    { nutrient: '碳水化合物', content: '10.0 g', dailyPercentage: '3%' },
                    { nutrient: '钙', content: '180.0 mg', dailyPercentage: '18%' }
                ]
            },

            // 营养素编辑表单
            nutrientForm: {
                nutrient: '',
                content: '',
                dailyPercentage: ''
            },

            // 当前编辑的营养素索引
            currentNutrientIndex: -1,

            // 表单校验规则
            templateRules: {
                pname: [
                    { required: true, message: '请输入模版名称', trigger: 'blur' }
                ],
                ptype: [
                    { required: true, message: '请选择模版类别', trigger: 'change' }
                ],
                alDay: [
                    { required: true, message: '请输入预警天数', trigger: 'blur' },
                    { type: 'number', min: 1, message: '预警天数不能小于1', trigger: 'blur' }
                ],
                alNum: [
                    { required: true, message: '请输入预警数量', trigger: 'blur' },
                    { type: 'number', min: 1, message: '预警数量不能小于1', trigger: 'blur' }
                ],
                punit: [
                    { required: true, message: '请选择单位', trigger: 'change' }
                ],
                yieldRate: [
                    { required: true, message: '请输入成品率', trigger: 'blur' },
                    {
                        validator: (rule, value, callback) => {
                            const numVal = Number(value);
                            if (isNaN(numVal)) {
                                callback(new Error('成品率必须为数字'));
                            } else if (numVal < 0 || numVal > 1) {
                                callback(new Error('成品率必须在0~1之间（如0.8）'));
                            } else {
                                callback();
                            }
                        },
                        trigger: 'blur'
                    }
                ]
            },

            // 营养素表单校验规则
            nutrientRules: {
                nutrient: [
                    { required: true, message: '请输入营养素名称', trigger: 'blur' }
                ],
                content: [
                    { required: true, message: '请输入含量', trigger: 'blur' }
                ],
                dailyPercentage: [
                    { required: true, message: '请输入每日参考值%', trigger: 'blur' }
                ]
            }
        }
    },

    mounted() {
        this.getTemplateList();
        this.$echarts = echarts;
    },

    methods: {
        // 前端兜底筛选方法
        filterTemplateData(rawData) {
            if (!Array.isArray(rawData)) return [];

            return rawData.filter(item => {
                // 1. 模版名称筛选（模糊匹配，不区分大小写）
                if (this.searchForm.pName) {
                    const keyword = this.searchForm.pName.toLowerCase().trim();
                    const pname = (item.pname || '').toLowerCase();
                    if (!pname.includes(keyword)) {
                        return false;
                    }
                }

                // 2. 模版类别筛选（精确匹配）
                if (this.searchForm.pType) {
                    if (item.ptype !== this.searchForm.pType) {
                        return false;
                    }
                }

                return true;
            });
        },

        // 获取模版列表（修复筛选逻辑）
        getTemplateList() {
            // 构建筛选参数
            const params = {
                userId: localStorage.getItem('userId'),
                pName: this.searchForm.pName.trim() || '',
                pType: this.searchForm.pType || ''
            };

            getAllProducts(params).then(response => {
                // 先通过后端筛选，再做前端兜底筛选
                const rawData = response.data || [];
                this.templateList = this.filterTemplateData(rawData);
                this.totalCount = this.templateList.length;
                // 重置页码为第一页
                this.currentPage = 1;
            }).catch(error => {
                console.error('获取模版列表失败:', error);
                this.$message.error('获取数据失败，请重试');
                this.templateList = [];
                this.totalCount = 0;
            });
        },

        // 重置搜索
        resetSearch() {
            this.searchForm = { pName: '', pType: '' };
            this.currentPage = 1;
            this.getTemplateList();
        },

        // 分页相关
        handleSizeChange(val) {
            this.pageSize = val;
            this.currentPage = 1;
            this.getTemplateList();
        },
        handleCurrentChange(val) {
            this.currentPage = val;
        },

        // 新增模版弹窗
        showAddTemplateDialog() {
            this.currentOperation = 'add';
            this.dialogTitle = '新增模版';
            this.formDialogVisible = true;
            this.templateForm = {
                pname: '',
                ptype: '',
                proImgPath: '',
                file: null,
                userId: localStorage.getItem('userId'),
                alDay: '',
                alNum: '',
                punit: '',
                yieldRate: '1'  // 成品率默认字符串'1'
            };
            this.$nextTick(() => {
                this.$refs.templateFormRef.clearValidate();
            });
        },

        // 编辑模版弹窗
        showEditDialog(row) {
            this.currentOperation = 'edit';
            this.dialogTitle = '编辑模版';
            this.formDialogVisible = true;
            // 回显数据时处理成品率（强制修正大于1的值，转为字符串）
            const yieldRate = Number(row.yieldRate) || 1;
            const fixedYieldRate = yieldRate > 1 ? 1 : yieldRate;
            this.templateForm = {
                ...row,
                yieldRate: fixedYieldRate.toFixed(2), // 转为两位小数的字符串
                file: null  // 编辑时清空文件对象
            };
            this.$nextTick(() => {
                this.$refs.templateFormRef.clearValidate();
            });
        },

        // 核心修复1：输入时仅过滤非法字符（允许数字和单个小数点）
        handleYieldRateInputFormat() {
            let val = this.templateForm.yieldRate;
            if (!val) return;

            // 只保留数字和一个小数点
            val = val.replace(/[^0-9.]/g, '');
            // 确保只有一个小数点（避免输入多个.）
            if (val.split('.').length > 2) {
                val = val.substring(0, val.lastIndexOf('.'));
            }
            this.templateForm.yieldRate = val;
        },

        // 核心修复2：失焦时校验范围并格式化（保留两位小数）
        handleYieldRateBlur() {
            let val = this.templateForm.yieldRate.trim();
            // 空值处理：默认设为'1'
            if (!val) {
                this.templateForm.yieldRate = '1';
                return;
            }

            // 转为数值类型
            let numVal = Number(val);
            // 非数字处理（如只输入了小数点）
            if (isNaN(numVal) || val === '.') {
                this.templateForm.yieldRate = '1';
                this.$message.warning('成品率必须为数字，已自动修正为1');
                return;
            }

            // 限制范围：0~1
            if (numVal > 1) {
                this.templateForm.yieldRate = '1';
                this.$message.warning('成品率不能大于1，已自动修正为1');
            } else if (numVal < 0) {
                this.templateForm.yieldRate = '0';
                this.$message.warning('成品率不能小于0，已自动修正为0');
            } else {
                // 保留两位小数，转为字符串（避免显示多位小数）
                this.templateForm.yieldRate = numVal.toFixed(2);
            }
        },

        // 图片选择变化：保存文件对象和预览URL
        handleImageChange(file) {
            // 保存文件对象（用于上传）
            this.templateForm.file = file.raw;
            // 生成预览URL（用于页面显示）
            this.templateForm.proImgPath = URL.createObjectURL(file.raw);
            console.log('图片文件对象:', this.templateForm.file);
            console.log('预览URL:', this.templateForm.proImgPath);
        },

        // 移除图片
        handleImageRemove() {
            // 释放预览URL内存
            if (this.templateForm.proImgPath) {
                URL.revokeObjectURL(this.templateForm.proImgPath);
            }
            this.templateForm.file = null;
            this.templateForm.proImgPath = '';
        },

        // 图片上传前校验（200KB限制）
        beforeImageUpload(file) {
            const isJPG = file.type === 'image/jpeg' || file.type === 'image/png';
            const isLt200K = file.size / 1024 < 200;

            if (!isJPG) this.$message.error('只能上传 JPG/PNG 格式的图片');
            if (!isLt200K) this.$message.error('图片大小不能超过 200KB');

            return isJPG && isLt200K;
        },

        // 提交表单（核心：FormData文件上传，成品率转为数值）
        submitTemplateForm() {
            this.$refs.templateFormRef.validate((isValid) => {
                if (isValid) {
                    // 创建FormData对象
                    const formData = new FormData();

                    formData.append('pName', this.templateForm.pname);
                    formData.append('pType', this.templateForm.ptype);
                    formData.append('userId', localStorage.getItem('userId'));
                    formData.append('alDay', this.templateForm.alDay);
                    formData.append('alNum', this.templateForm.alNum);
                    formData.append('pUnit', this.templateForm.punit);
                    formData.append('yieldRate', Number(this.templateForm.yieldRate)); // 转为数值提交
                    formData.append('editId', this.templateForm.pid);

                    // 添加图片文件（若有）
                    if (this.templateForm.file) {
                        formData.append('file', this.templateForm.file);
                    }

                    // 调用API
                    const apiMethod = this.currentOperation === 'add' ? addProducts : editProducts;
                    apiMethod(formData).then(response => {
                        console.log(response);
                        this.formDialogVisible = false;
                        this.$message.success(`${this.currentOperation === 'add' ? '新增' : '编辑'}模版成功`);
                        this.getTemplateList(); // 刷新列表
                    }).catch(error => {
                        console.error('提交失败:', error);
                        this.$message.error(`${this.currentOperation === 'add' ? '新增' : '编辑'}模版失败，请重试`);
                    });
                }
            });
        },

        // 删除模版
        handleDeleteTemplate(id) {
            this.$confirm('此操作将删除该模版, 是否继续?', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                delProducts({
                    userId: localStorage.getItem('userId'),
                    pid: id
                }).then(() => {
                    this.$message.success('模版已删除');
                    this.getTemplateList();
                }).catch(error => {
                    console.error('删除失败:', error);
                    this.$message.error('删除模版失败，请重试');
                });
            }).catch(() => {
                this.$message.info('已取消操作');
            });
        },

        // 表格行点击
        handleRowClick(row) {
            this.$refs.tableRef.toggleRowSelection(row);
        },

        // 营养分析弹窗
        showNutritionAnalysis(row) {
            console.log(row);
            this.nutritionDialogVisible = true;
            this.$nextTick(() => this.initCharts());
        },

        // 初始化图表
        initCharts() {
            const pieChartDom = document.getElementById('nutritionPieChart');
            if (pieChartDom) {
                const pieChart = this.$echarts.init(pieChartDom);
                pieChart.clear();
                pieChart.setOption({
                    title: { text: '营养成分占比' },
                    tooltip: { trigger: 'item' },
                    legend: { orient: 'vertical', left: 10, top: 30 },
                    series: [{
                        type: 'pie',
                        radius: '70%',
                        data: [
                            { value: this.nutritionData.protein, name: '蛋白质' },
                            { value: this.nutritionData.fat, name: '脂肪' },
                            { value: this.nutritionData.carbohydrate, name: '碳水化合物' }
                        ]
                    }]
                });
                window.addEventListener('resize', () => pieChart.resize());
            }
        },

        // 营养素编辑相关
        editNutrient(row) {
            this.currentNutrientIndex = this.nutritionData.details.findIndex(item => item.nutrient === row.nutrient);
            this.nutrientForm = { ...row };
            this.nutrientDialogVisible = true;
        },
        deleteNutrient(index) {
            this.nutritionData.details.splice(index, 1);
            this.$message.success('营养素已删除');
        },
        addNutrient() {
            this.currentNutrientIndex = -1;
            this.nutrientForm = { nutrient: '', content: '', dailyPercentage: '' };
            this.nutrientDialogVisible = true;
        },
        saveNutrient() {
            this.$refs.nutrientFormRef.validate((isValid) => {
                if (isValid) {
                    if (this.currentNutrientIndex === -1) {
                        this.nutritionData.details.push({ ...this.nutrientForm });
                    } else {
                        this.nutritionData.details[this.currentNutrientIndex] = { ...this.nutrientForm };
                    }
                    this.nutrientDialogVisible = false;
                    this.$message.success('营养素保存成功');
                    if (this.activeTab === 'nutritionChart') {
                        this.initCharts();
                    }
                }
            });
        }
    },

    beforeDestroy() {
        // 清除图片预览URL，释放内存
        if (this.templateForm.proImgPath) {
            URL.revokeObjectURL(this.templateForm.proImgPath);
        }
        // 移除图表监听
        window.removeEventListener('resize', () => {
            const pieChart = this.$echarts.getInstanceByDom(document.getElementById('nutritionPieChart'));
            if (pieChart) pieChart.resize();
        });
    },

    // 关闭弹窗时释放图片预览URL
    watch: {
        formDialogVisible(newVal) {
            if (!newVal && this.templateForm.proImgPath) {
                URL.revokeObjectURL(this.templateForm.proImgPath);
            }
        }
    }
}
</script>

<style lang="scss" scoped>
.table-header {
    background-color: rgb(230, 242, 255) !important;
    font-weight: bold;
}

.text-red-500 {
    color: #f56c6c;
}

.text-gray-400 {
    color: #c0c4cc;
}

.demo-form-inline {
    display: flex;
    align-items: center;
    flex-wrap: wrap;
    gap: 16px;
}

.el-dialog__body {
    padding: 20px;
    max-height: 70vh;
    overflow-y: auto;
}

.el-form-item {
    margin-bottom: 20px;
}

/* 营养分析样式 */
.nutrition-analysis {
    .nutrition-summary {
        display: flex;
        justify-content: space-around;
        margin-bottom: 20px;
        flex-wrap: wrap;
        gap: 10px;

        .nutrition-card {
            text-align: center;
            width: 20%;
            min-width: 120px;
            border: 1px solid #eee;
            border-radius: 4px;
            padding: 10px;
            background-color: #f9f9f9;

            h3 {
                font-size: 16px;
                margin-bottom: 10px;
                color: #666;
            }

            .value {
                font-size: 20px;
                font-weight: bold;
                margin-bottom: 5px;
                color: #333;
            }

            .reference {
                font-size: 12px;
                color: #999;
            }
        }
    }

    .chart-container {
        margin-top: 20px;
        width: 100%;
    }
}

/* 弹窗层级与图片预览样式 */
::v-deep .el-dialog__wrapper {
    z-index: inherit !important;
}

::v-deep .el-image-viewer__wrapper {
    z-index: 3000 !important;
}

::v-deep .el-tabs__content {
    height: 100%;
}

/* 图片悬停效果 */
::v-deep .el-image {
    transition: transform 0.2s;

    &:hover {
        transform: scale(1.05);
    }
}

/* 成品率输入框提示样式 */
::v-deep .el-input__append {
    background-color: #f5f7fa;
    border-left: none;
    color: #909399;
    font-size: 12px;
}
</style>